import {Helmet} from '@dr.pogodin/react-helmet';
import {Space, VStack} from 'platform/foundation';

import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';

import {
  useGetSelectableMaterialQuery,
  useGetSelectableMaterialsIntegrationsQuery,
} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {SelectableMaterialsDetailExternalSundries} from './components/SelectableMaterialsDetailExternalSundries';
import {SelectableMaterialsDetailFooter} from './components/SelectableMaterialsDetailFooter';

export function WorkshopSelectableMaterialsDetail() {
  const {id} = useParams();

  const {integrationOptions, isLoadingIntegrations, isIntegrationsError} =
    useGetSelectableMaterialsIntegrationsQuery(undefined, {
      selectFromResult: (result) => ({
        integrationOptions:
          result.data?.map((integration) => ({
            value: integration.integrationId,
            label: integration.name,
          })) ?? [],
        isLoadingIntegrations: result.isLoading,
        isIntegrationsError: result.isError,
      }),
    });

  const selectableMaterialQuery = useGetSelectableMaterialQuery(
    {
      selectableMaterialId: id as string,
    },
    {skip: isNil(id)}
  );

  const integrationName =
    integrationOptions.find(
      (integration) => integration.value === selectableMaterialQuery.data?.integrationId
    )?.label ?? '';

  const isLoading = isLoadingIntegrations || selectableMaterialQuery.isLoading;

  const isError = isIntegrationsError || selectableMaterialQuery.isError;

  return (
    <>
      <Helmet title={i18n.t('page.settings.labels.selectableMaterialDetail')} />
      <SettingsTemplate
        header={{
          title: integrationName,
          breadcrumbs: [
            {
              label: i18n.t('page.settings.labels.selectableMaterials'),
              href: settingsRoutes.workshopSelectableMaterials,
            },
          ],
        }}
        isLoading={isLoading}
        isError={isError}
        data-testid={testIds.settings.workshopSelectableMaterialsDetail('template')}
      >
        <VStack spacing={6}>
          <SelectableMaterialsDetailExternalSundries
            integrationId={selectableMaterialQuery.data?.integrationId as string}
          />
          <Space fillAvailable />
          <SelectableMaterialsDetailFooter />
        </VStack>
      </SettingsTemplate>
    </>
  );
}
